const itemTypes = new Set(['driver', 'truck', 'trailer', 'allocated_route']);

export const writeRouteDragData = (dataTransfer, type, item) => {
    if (!itemTypes.has(type)) throw new Error('Unsupported routing drag type.');
    dataTransfer.effectAllowed = 'move';
    // Write the portable format first; browsers normalize custom format names.
    dataTransfer.setData('text/plain', JSON.stringify({ type, item }));
    dataTransfer.setData('itemType', type);
    dataTransfer.setData('itemData', JSON.stringify(item));
};

export const readRouteDragData = (dataTransfer) => {
    const text = dataTransfer.getData('text/plain');
    const payload = text
        ? JSON.parse(text)
        : {
            type: dataTransfer.getData('itemType'),
            item: JSON.parse(dataTransfer.getData('itemData') || 'null'),
        };
    if (!itemTypes.has(payload?.type) || !payload.item || typeof payload.item !== 'object') {
        throw new Error('Drop a routing driver, vehicle or route.');
    }
    return payload;
};

export const allowRouteDrop = (event) => {
    event.preventDefault();
    event.dataTransfer.dropEffect = 'move';
};
